// extracted by mini-css-extract-plugin
module.exports = {"cp-course-content":"styles_cp-course-content__MH-5z","cp-course-content__text":"styles_cp-course-content__text__2CYpB"};